import { render } from "./SterfietsRoutes.vue?vue&type=template&id=6c65b548"
import script from "./SterfietsRoutes.vue?vue&type=script&lang=js"
export * from "./SterfietsRoutes.vue?vue&type=script&lang=js"

import "./SterfietsRoutes.vue?vue&type=style&index=0&id=6c65b548&lang=css"

import exportComponent from "/buddy/denhaagfietst-sterfietsroutes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__